export const languageConstants = {
    GETALL_CODES_REQUEST: 'GETALL_CODES_REQUEST',
    GETALL_CODES_SUCCESS: 'GETALL_CODES_SUCCESS',
    GETALL_CODES_FAILURE: 'GETALL_CODES_FAILURE',

    GETALL_CODES_BY_EVENT_REQUEST: 'GETALL_CODES_BY_EVENT_REQUEST',
    GETALL_CODES_BY_EVENT_SUCCESS: 'GETALL_CODES_BY_EVENT_SUCCESS',
    GETALL_CODES_BY_EVENT_FAILURE: 'GETALL_CODES_BY_EVENT_FAILURE',


    //and so on
};